import { LAYOUTS, } from '@voltmoney/types';
import { CalendarStateToken, InputStateToken, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION } from './types';
import { closeModal, closePanModal, confirmPan, Continue, editDetailsAction, fetchExistingPan, goBack, needHelp, toggleCTA, ValidateDob, ValidateForm, ValidatePan, verifyPan } from './actions';
import SharedPropsService from '../../../../SharedPropsService';
import { getAppHeader, } from '../../../../configs/config';
import { api } from '../../../../configs/api';
import sharedPropsService from "../../../../SharedPropsService";
import { getContactUsDetails } from '../../../../configs/utils';
export const template = (height, applicationId, targetRoute, dob, setIsUserLoggedIn, isPanValidated, isFromPhonePe, contactUsDetails, isFromJupiter) => {
    return {
        layout: {
            id: ROUTE.KYC_PAN_VERIFICATION,
            style: {
                isPartnerPlatform: true
            },
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'kycPanVerification', type: WIDGET.KYC_PAN_VERIFICATION_PAGE
                },
            ],
        },
        datastore: {
            kycPanVerification: {
                height,
                needHelpAction: {
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_verifyPanScreen_needHelp' }
                },
                goBackAction: {
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    type: ACTION.GO_BACK,
                    payload: { id: 'bt_verifyPanScreen_goBack' }
                },
                panAction: {
                    type: ACTION.VALIDATE_PAN,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                dobAction: {
                    type: ACTION.VALIDATE_DOB,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                continueAction: {
                    type: ACTION.CONTINUE,
                    payload: {
                        applicationId,
                    },
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                confirmPanAction: {
                    type: ACTION.CONFIRM_PAN,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                closePanModal: {
                    type: ACTION.CLOSE_MODAL,
                    payload: {},
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                },
                state: InputStateToken.DEFAULT,
                dobState: CalendarStateToken.DEFAULT,
                caption: { error: "Please enter a valid PAN number" },
                userName: "",
                year: {
                    id: 'tf_verifyPanScreen_enterYear',
                    title: 'Year',
                    value: `${dob.substring(6)}`,
                    placeholder: 'YYYY',
                },
                month: {
                    id: 'tf_verifyPanScreen_enterMonth',
                    title: 'Month',
                    value: `${dob.substring(3, 5)}`,
                    placeholder: 'MM',
                },
                date: {
                    id: 'tf_verifyPanScreen_enterDate',
                    title: 'Date',
                    value: `${dob.substring(0, 2)}`,
                    placeholder: 'DD',
                },
                prefilledPanNumber: '',
                showKycModal: false,
                counter: 0,
                showErrorModal: false,
                errorMessage: '',
                contactUsDetails,
                modalHeight: 0,
                fetchedData: true,
                isFromJupiter: isFromJupiter,
                editDetailsAction: {
                    type: ACTION.EDIT_DETAILS_ACTION,
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    payload: {}
                },
                closeModal: {
                    type: ACTION.CLOSE_PAN_MODAL,
                    routeId: ROUTE.KYC_PAN_VERIFICATION,
                    payload: {}
                }
            },
        },
    };
};
export const panVerifyMF = {
    onLoad: async ({ instrumentTrack, network, getHeight, setDatastore }, { applicationId, targetRoute, setIsUserLoggedIn }) => {
        instrumentTrack('ENTER_PAN_PAGE_VIEWED');
        const user = await SharedPropsService.getUser();
        const accountId = user.linkedBorrowerAccounts[0].accountId;
        const contactUsDetails = await getContactUsDetails();
        // ---- RESET state in case of LENDER change ---- //
        await sharedPropsService.setIsFetchedErrorShowOnce(false);
        // ---------------------------------------------- //
        const isPanValdiated = await SharedPropsService.isPanValidated();
        const isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        let dob = '';
        const response = await network
            .get(`${api.userProfile}${accountId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        })
            .then(response => response.data);
        const prefilledPanNumber = response.panNumber;
        console.warn("BVH prefilledPanNumber", prefilledPanNumber);
        await setDatastore(ROUTE.KYC_PAN_VERIFICATION, 'kycPanVerification', {
            prefilledPanNumber: prefilledPanNumber,
        });
        await setDatastore(ROUTE.KYC_PAN_VERIFICATION, 'kycPanVerification', {
            fetchedData: true,
        });
        return Promise.resolve(template(getHeight(), applicationId, targetRoute, dob, setIsUserLoggedIn, isPanValdiated, isFromPhonePe, contactUsDetails, isFromJupiter));
    },
    actions: {
        [ACTION.VERIFY_PAN]: verifyPan,
        [ACTION.VALIDATE_FORM]: ValidateForm,
        [ACTION.VALIDATE_PAN]: ValidatePan,
        [ACTION.VALIDATE_DOB]: ValidateDob,
        [ACTION.CONTINUE]: Continue,
        [ACTION.ENABLE_CONTINUE]: toggleCTA,
        [ACTION.DISABLE_CONTINUE]: toggleCTA,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_BACK]: goBack,
        [ACTION.CONFIRM_PAN]: confirmPan,
        [ACTION.CLOSE_MODAL]: closePanModal,
        [ACTION.ON_LOAD]: fetchExistingPan,
        [ACTION.EDIT_DETAILS_ACTION]: editDetailsAction,
        [ACTION.CLOSE_PAN_MODAL]: closeModal,
    },
};
